import React from "react";
import Layout from '../layouts/Layout';
import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
// import FreeConsultationModal from '../components/FreeConsultationModal';
import Link from 'next/link';
import { MdAccountBalance } from '@react-icons/all-files/md/MdAccountBalance';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
const CustomImage = dynamic(() => import('../components/CustomImage'))

export default class MBA extends React.Component {

    state = {
        testimonials: [
            {
                text: 'My mentors and counsellors helped me determine the best colleges for me by helping me shortlist my areas of expertise and interest.',
                user: 'Siddhartha G.',
                image: 'columbia.png'
            },
            {
                text: 'My mentor and counsellors at Collegify have been both perceptive about my needs and enthusiastic about making my application stand out.',
                user: 'Satya G.',
                image: 'iim.png'
            },
            {
                text: 'Collegify’s personalized approach to the essay ideation process helped me find my best fit college based on my profile.',
                user: 'Nakul J.',
                image: 'nus.jpg'
            }
        ],
        selectedTestimonial: {}
    }

    componentDidMount() {
        document.querySelector('body').classList.add('overflow-toggle');
        this.initScroll();
    }

    componentWillUnmount() {
        document.querySelector('body').classList.remove('overflow-toggle');
        clearInterval(this.testimonialInterval)
    }

    initScroll = () => {
        let menuSection = document.querySelectorAll('.admissions-inner-nav-item');

        // for clickable event
        menuSection.forEach(v=> {
            v.onclick = (()=> {
                setTimeout(()=> {
                    menuSection.forEach(j=> j.classList.remove('active'))
                    v.classList.add('active')
                },300);
            });
        })

        // for window scrolldown event

        window.onscroll = (()=> {
            let mainSection = document.querySelectorAll('.ug-nav-item');

            mainSection.forEach((v,i)=> {
                let rect = v.getBoundingClientRect().y
                if(rect < window.innerHeight - 500){
                menuSection.forEach(v=> v.classList.remove('active'))
                menuSection[i].classList.add('active')
                }
            });
        });
    }

    render() {
        return (
            <Layout>

                {
                    process.env.NEXT_PUBLIC_ENV === 'production' &&
                    <NextSeo
                        title='MBA Admissions Consulting - Study Abroad'
                        titleTemplate='Collegify | %s'
                        copyright='Collegify has copyrights to all the content on the page.'
                        keywords='best-fit college,simplify application processes,create winning applications,mentoring services,social service projects,international,undergraduate,test guidance,management,college research,college shortlist,resume building,letter of recommendation, application essays,forms,financial aid,sat,act'
                        description='Collegify began as a bespoke education services company specializing in College Admissions Consulting, Career Guidance and Test Preparation Services.'
                        openGraph={{
                            url: process.env.NEXT_PUBLIC_APP_URI + "/mba",
                            title: 'Collegify | MBA Admissions Consulting - Study Abroad',
                            type: 'website',
                            description: 'Collegify began as a bespoke education services company specializing in College Admissions Consulting, Career Guidance and Test Preparation Services.',
                            images: [
                                {
                                    url: process.env.NEXT_PUBLIC_FILE_URI + 'social-banner/mba.jpg',
                                    width: 500,
                                    height: 500,
                                    alt: 'A Holistic Approach to College Admissions',
                                },
                            ],
                            site_name: 'Collegify',
                        }}
                    />
                }

                <div id="admissions-mba" className="admissions-inner-page">

                    {/* Admissions Inner Intro Section */}
                    <section className="nav-margin admissions-intro-section">
                        <div className="container">

                            <div className="flex-center">
                                <div className="admissions-yellow-icon mb-4">
                                    <MdAccountBalance className="material-icons" />
                                </div>
                            </div>

                            <div className="text-center mb-5">
                                <div className="row justify-content-center">
                                    <div className="col-md-8 col-lg-7">
                                        <h2 className="mb-2">MBA Admissions</h2>
                                        <p>Collegify’s team of MBA Admissions Consultants specialize in guiding aspiring MBA applicants through challenging B-School applications.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-center mb-3">

                                        <button className="btn btn-primary text-white btn-with-icon" data-bs-toggle="modal" data-bs-target="#freeConsultationModal">
                                            Book A Consultation
                                            <span className="btn-icon"><MdArrowForward className="material-icons" /></span>
                                        </button>

                            </div>

                        </div>
                    </section>

                    {/* Light Yellow Curve SVG */}
                    <div><img src="/images/curve-light-yellow-bottom.svg" alt="background mba" /></div>

                    {/* Testimonial Card */}
                    <section className="negative-margin-card mb-5 pb-5">
                        <div className="container">
                            <div className="card">
                                <div className="card-body px-3 px-lg-5">
                                    <div className="flex-row align-items-center">
                                    <CustomImage srcSetPaths={[{path: '/common/quote-tint-start.svg?tr=w-60,f-avif', type: 'image/avif'},{path: '/common/quote-tint-start.svg?tr=w-60,f-auto', type: 'image/webp'}]}
                                            mainSrc="/common/quote-tint-start.svg?tr=w-60,f-png" alt="Quote Start" width="60px" height="40px" imgCDN className="d-none d-lg-block me-3" />
                                        <div className="testimonial-inner flex-row mx-0 mx-md-4 d-block d-md-flex gap-2ch">
                                            <div className="university-logo-container flex-center mb-4 mb-lg-0 flex-shrink-0">
                                                <CustomImage srcSetPaths={[{path: '/university-logos/columbia-university.png?tr=w-90,f-avif', type: 'image/avif'},{path: '/university-logos/columbia-university.png?tr=w-90,f-auto', type: 'image/webp'}]}
                                                    mainSrc="/university-logos/columbia-university.png?tr=w-90,f-png" alt="Columbia University Logo" height="auto" width="90px" imgCDN />

                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="testimonial-content mb-2">My mentors and counsellors helped me determine the best colleges for me by helping me shortlist my areas of expertise and interest.</p>
                                                <h5 className="testimonial-user">Siddhartha G.</h5>
                                            </div>
                                        </div>
                                        <CustomImage srcSetPaths={[{path: '/common/quote-tint-end.svg?tr=w-60,f-avif', type: 'image/avif'},{path: '/common/quote-tint-end.svg?tr=w-60,f-auto', type: 'image/webp'}]}
                                            mainSrc="/common/quote-tint-end.svg?tr=w-60,f-png" alt="Quote End" width="60px" height="40px" imgCDN className="d-none d-lg-block ms-3" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="container">

                        <div className="row no-gutters">

                            {/* MBA Navigation */}
                            <div className="col-md-4">
                                <div className="admissions-inner-nav ug-inner-nav">
                                    <div className="mb-4">
                                        <div className="admissions-inner-nav-item active"><a><h5>Who We Are</h5></a></div>
                                        <div className="admissions-inner-nav-item"><a><h5>MBA Services</h5></a></div>
                                        <div className="admissions-inner-nav-item"><a><h5>The Collegify Difference</h5></a></div>
                                    </div>

                                            <button className="btn btn-primary text-white" data-bs-toggle="modal" data-bs-target="#freeConsultationModal">
                                                Book A Consultation
                                            </button>

                                </div>
                            </div>

                            {/* MBA Details */}
                            <div className="col-md-8">

                                <div className="mb-5">
                                    <h3 className="mb-4 heading-with-hr ug-nav-item">Who We Are</h3>
                                    <p>Collegify Mentors are carefully selected, not just for their exposure and
                                            industry knowledge, but also for their ability to interact with young adults
                                            as guides, teachers, and coaches. We not only ensure that you find your
                                            ‘Best Fit’ B-School, but also match you to your Best Fit’ Mentor who will be
                                            your primary point of contact throughout the process for ease of access and
                                            coordination. There will also be a Secondary Mentor available to give you a
                                            wider perspective whenever required.</p>
                                </div>

                                <div className="mb-5">
                                    <h3 className="mb-4 heading-with-hr ug-nav-item">MBA Services</h3>

                                    {/* Accordion */}
                                    <div className="accordion" id="mba-services">

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingOne">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Career Mapping
                                                </button>
                                            </h4>
                                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>We conduct an in-depth analysis of the student’s
                                                        professional trajectory and career goals to determine whether an
                                                        MBA is the ideal way forward. We also present the student with a
                                                        roadmap and tentative timeline that they should follow to
                                                        achieve their academic, career and personal goals.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingTwo">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                GMAT Test Prep
                                                </button>
                                            </h4>
                                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>The GMAT plays a key role in the B-school
                                                        application process. At Collegify, we provide one-on-one
                                                        coaching for GMAT prep, which allows students to identify their
                                                        strengths and areas of improvement and follow a customized
                                                        test-taking strategy. Our faculty is equipped with industry
                                                        experience spanning over a decade. Their guidance and constant
                                                        reviews help students maximize their potential. </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingThree">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Resume Building / Profile Development
                                                </button>
                                            </h4>
                                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>While relevant work experience and good GMAT
                                                        scores are an important part of an effective MBA application, a
                                                        student must also showcase a strong well-rounded profile to make
                                                        it to the top B-schools around the world. Collegify evaluates a
                                                        student’s resume and provides expert recommendations to help
                                                        them improve and strengthen their profile undertaking additional
                                                        responsibilities at work, switching companies, taking on
                                                        community service or subscribing to additional academic courses,
                                                        both online and otherwise.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingFour">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                Choice of B-School
                                                </button>
                                            </h4>
                                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>At Collegify, we employ a very scientific and
                                                        logical approach when creating the B-School shortlists to ensure
                                                        that it complements the student’s profile, career goals,
                                                        preferred area of specialization and probable field of
                                                        employment post MBA. We also consult several rankings and other
                                                        resources to determine the credibility of the chosen B-schools
                                                        and ROI.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingFive">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                Resume Editing
                                                </button>
                                            </h4>
                                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>Students’ resumes often flow into several pages,
                                                        which is against the one-page resume norm of B-schools. We guide
                                                        them on first sifting information and discerning their
                                                        achievements and unique aspects. Further, we edit the resume
                                                        several times till it perfectly and aptly reflects the student’s
                                                        key achievements and experiences, both within and beyond the
                                                        workplace, without spilling over the one-page limit.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingSix">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                                Essay Ideation and Editing
                                                </button>
                                            </h4>
                                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>B-school essays are a crucial medium to showcase
                                                        one’s experiences, learning and ideas. Writing essays and
                                                        expressing one’s thoughts in words is also one of the biggest
                                                        challenges faced by B-school applicants. However, B-school
                                                        application essays often lack clarity of thought and structure,
                                                        belie poor writing skills, offer conflicting narratives or
                                                        simply duplicate the resume. Collegify conducts extensive essay
                                                        ideation sessions and helps students create essays that retain
                                                        their personal style, while serving as effective narratives.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingSeven">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                                Choice of referees and drafting Letters of Recommendation
                                                </button>
                                            </h4>
                                            <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>Letters of Recommendation substantiate a
                                                        student’s strengths, potential for graduate studies and
                                                        contribution to the organizations they have worked in. We at
                                                        Collegify, guide students to help them select the most effective
                                                        referees. Students sometimes have to draft these letters on
                                                        behalf of their referees and in such situations, we help them
                                                        create professional Letters of Recommendation that best
                                                        exemplify their strengths and achievements.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingEight">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                                Application Submission
                                                </button>
                                            </h4>
                                            <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>Application forms are extensive and require various
                                                    details ranging from a student’s personal details to internship
                                                    responsibilities. Every piece of information needs to be validated
                                                    through relevant documents, which are uploaded in the application
                                                    form. At Collegify, we check each form to ensure flawless and
                                                    seamless submission.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingNine">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                                Interview Preperation
                                                </button>
                                            </h4>
                                            <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>Interviews are an integral part of the PG
                                                    application process as they provide Interviewers an estimation of
                                                    the student’s personality, communication skills and verifies their
                                                    identity of the interviewee against their claims in the application.
                                                    Collegify organizes numerous mock interview sessions to prepare
                                                    students to field challenging questions, rebuttals and offers
                                                    further guidance on their demeanour and delivery to help them ace
                                                    their interviews.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="headingTen">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                                The Final Decision
                                                </button>
                                            </h4>
                                            <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#mba-services">
                                                <div className="accordion-body">
                                                    <p>Our students are frequently left with more than one
                                                    university to choose from. Our team conducts extensive discussions
                                                    with students to help them zero in on their ‘Best Fit’ University
                                                    and Program that aligns with their individual requirements,
                                                    interests and location preferences.</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="mb-5">
                                    <h3 className="mb-4 heading-with-hr ug-nav-item">The Collegify Difference</h3>

                                    {/* Accordion */}
                                    <div className="accordion" id="diff-accordion">

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-One">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-One" aria-expanded="true" aria-controls="collapse-One">
                                                 I am looking for individual attention. Will I receive adequate personal attention?
                                                </button>
                                            </h4>
                                            <div id="collapse-One" className="accordion-collapse collapse show" aria-labelledby="heading-One" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>Our customized Personal Mentoring Program includes one-on-one meetings
                                                        with students to understand their potential, individual requirements and
                                                        counsel them effectively through the admission cycle.
                                                    <br/><br/>
                                                        This Program will consider your goals and aspirations, highlight your
                                                        unique strengths, identify areas of improvement and create a roadmap for
                                                        a successful application.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-Two">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-Two" aria-expanded="false" aria-controls="collapse-Two">
                                                What if I need to boost my GRE/GMAT score? Can Collegify help?
                                                </button>
                                            </h4>
                                            <div id="collapse-Two" className="accordion-collapse collapse" aria-labelledby="heading-Two" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>Absolutely! Collegify offers premium Classroom Coaching and Private
                                                        Tutoring Services for Standardized Test Preparation.
                                                    <br/><br/>
                                                        Our experienced GRE/GMAT faculty will conduct regular sessions to guide
                                                        you through the Test and you may further augment your skills by
                                                        enrolling on to the Collegify E-Learning Platform to access our Online
                                                        Test Prep Services and exclusive resources.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-Three">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-Three" aria-expanded="false" aria-controls="collapse-Three">
                                                Do I need to have work experience?
                                                </button>
                                            </h4>
                                            <div id="collapse-Three" className="accordion-collapse collapse" aria-labelledby="heading-Three" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>WWork experience is always highly recommended for PG aspirants. Top tier
                                                graduate programs value student involvement in academic projects,
                                                internships, and research endeavours relevant to your intended area of
                                                specialization.
                                                    <br/><br/>
                                                Professional experience, academic publications and contributions to
                                                research projects will always give you an edge over other PG applicants.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-Four">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-Four" aria-expanded="false" aria-controls="collapse-Four">
                                                When is the right time for me to begin the application process?
                                                </button>
                                            </h4>
                                            <div id="collapse-Four" className="accordion-collapse collapse" aria-labelledby="heading-Four" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>We always recommend that students begin the Application Process early to
                                                for a stress free experience. However, it is never too late to seek our
                                                guidance at any time during the Admission Cycle.
                                                    <br/><br/>
                                                Collegify Mentors can assess your Profile at any step of the Application
                                                Process and provide you with actionable feedback to optimize your
                                                efforts and improve your application.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-Five">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-Five" aria-expanded="false" aria-controls="collapse-Five">
                                                Who will write my essay?
                                                </button>
                                            </h4>
                                            <div id="collapse-Five" className="accordion-collapse collapse" aria-labelledby="heading-Five" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>Our customized Personal Mentoring Program fosters strong Student-Mentor
                                                exchanges that facilitate a fruitful collaborative process leveraging
                                                your personal and professional experiences to create compelling
                                                narratives for application essays.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h4 className="accordion-header" id="heading-Six">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-Six" aria-expanded="false" aria-controls="collapse-Six">
                                                How is the collegify track record?
                                                </button>
                                            </h4>
                                            <div id="collapse-Six" className="accordion-collapse collapse" aria-labelledby="heading-Six" data-bs-parent="#diff-accordion">
                                                <div className="accordion-body">
                                                    <p>The Collegify Network currently spans all 8 Ivy League Colleges and the
                                                        best graduate schools around the world like Oxford, Cambridge, LSE,
                                                        Stanford, CalTech, MIT, UCL, UToronto, University of Melbourne,
                                                        University of Sydney, Le Cordon Bleu, ETH Zurich, Trinity College Dublin
                                                        and NUS amongst others.
                                                    <br/><br/>
                                                        Many of our students have secured Financial Aid Scholarships and
                                                        outperformed their initial expectations with the quality of their final
                                                        admits.
                                                    <br/><br/>
                                                        We also plug our new students into this network and facilitate
                                                        productive interactions between prospective applicants and Collegify
                                                        alumni. This unique learning opportunity could help you learn more about
                                                        the Universities you intend to apply to and understand the breadth of
                                                        experience it offers.</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* <FreeConsultationModal service="mba" /> */}

            </Layout>
        )
    }
}
